module.exports = __webpack_public_path__ + "static/media/14.d7c66940.png";